import React, { useState } from 'react'
import { Form, Input, Button, Card, Spin } from 'antd'
import { BiLogIn } from 'react-icons/bi'
import axios from 'axios'
import { Flip, toast } from 'react-toastify'
import Cookies from 'js-cookie'
import { useDispatch, useSelector } from 'react-redux'
import type { SelectProps } from 'antd/es/select'
import { loginUser } from '../features/auth/authAsyncThunk'
import { AUTH_URL } from '../constants'

export interface loginCredentials{
        email: string,
        password: string
    }

export interface DebounceSelectProps<ValueType = any>
  extends Omit<SelectProps<ValueType | ValueType[]>, 'options' | 'children'> {
  fetchOptions: (search: string) => Promise<ValueType[]>;
  debounceTimeout?: number;
}

    //Toaster
    export const toastStyle: any =  {
    background: '#ffffff',
    color: '#0a0a0a',
    fontSize: "13px",
    padding: '2px',
    position: 'bottom-center',
    fontStyle: 'bold'
    }

    export const toatStyles: any = {
    position: "bottom-right",
    autoClose: 5000,
    newestOnTop: false,
    rtl: false,
    pauseOnFocusLoss: true,
    draggable: true,
    pauseOnHover: true,
    theme: "dark",
    transition: "Bounce",
    }

    export const notify = (message: string, style: any) => toast.error(message, {
    style
    });;

    export const notify_success = (message: string, style: any) => toast.success(message, {
    style
    });

     export const notify_info = (message: string, style: any) => toast.info(message, 
     {
            position: "bottom-right",
            autoClose: 5000,
            rtl: false,
            pauseOnFocusLoss: true,
            draggable: true,
            pauseOnHover: true,
            theme: "dark",
            transition: Flip

            }
     );

const LoginPage = () => {

    const [email, setUsername] = useState("")
    const [password, setPassword] = useState("")
    const [otp, setOtp] = useState("")
    const [newPassword, setNewPassword] = useState("")
    const [newPasswordConfirm, setNewPasswordConfirm] = useState("")
    const [showLoginForm, setShowLoginForm] = useState(true)
    const [showResetForm, setShowResetForm] = useState(true)
    const [showTokenForm, setShowTokenForm] = useState(false)
    const [signingIn, setSigningIn] = useState(false)
    const [resetingPassword, setResetingPassword] = useState(false)
    const [requestingToken, setRequestingToken] = useState(false)

    const metadata = useSelector((state: any) => state.metadata)
    const system_ready = metadata.data.success
    const dispatch = useDispatch()
 
    const signIn = async()=>{
         dispatch(loginUser({ email, password}) as any);
        try {
            const login_response = await axios.post(`${AUTH_URL}/users/login`, {email, password})

            setSigningIn(false)
                

            if(login_response.data.success){
               notify_success(login_response.data.message, toastStyle,)
                Cookies.set('jwt', login_response.data.token, { expires: 7 });
              
            }else{
             
                notify(login_response.data.message, toastStyle,)

            }

        } catch (error) {  
           
        }
    }

     const requestResetToken = async()=>{
        try {
            let token_response: any = await axios.post(`${AUTH_URL}/users/forgot-password`, {email})
            setRequestingToken(false)

            if(token_response.data.success){
                notify_success(token_response.data.message, toastStyle,)
                setShowResetForm(true)
                setShowLoginForm(false)
                setShowTokenForm(false)
            }else{
                notify(token_response.data.message, toastStyle,)
            }

        } catch (error: any) {   
            notify(error.message, toastStyle,)
        }
    };

     const resetPassword = async()=>{
        try {
            const reset_response = await axios.post(`${AUTH_URL}/users/reset-password`, {email, otp, password: newPassword, passwordConfirm: newPasswordConfirm})
            setResetingPassword(false)
            if(reset_response.data.success){
                setShowResetForm(false)
                setShowLoginForm(true)
                setShowTokenForm(false)
                notify_success(reset_response.data.message, toastStyle)
            }else{
                notify(reset_response.data.message, toastStyle)
            }
            
        } catch (error:any) {   
            notify(error.message, toastStyle,)
        }
    }

  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center',
      padding: '20px',
      background: '#e8f6ff'
    }}>
      <div style={{ width: '100%', maxWidth: '400px' }}>
        {system_ready ? (
          <Card
            title={
              <div style={{ textAlign: 'center' }}>
                <h3 style={{ margin: '10px 0', fontWeight: 600 }} className='fw-bold'>DLMS</h3>
                <span style={{ fontSize: '10px' }} className='text-uppercase'>Digital Loan Management System</span>
              </div>
            }
            headStyle={{ background: '#001529', color: '#fff' }}
            style={{ borderRadius: '0px' }}
            className='rounded-0'
          >
            {showLoginForm ? (
              <Form layout="vertical" id="login-form">
                
                <Form.Item
                  label={<span style={{ fontWeight: 500, color: '#6c757d' }}>Email address</span>}
                  style={{ marginBottom: '16px' }}
                >
                  <Input
                    type="email"
                    value={email}
                    onChange={(e) => setUsername(e.target.value)}
                    placeholder="Enter your email"
                    size="large"
                  />
                </Form.Item>

                <Form.Item
                  label={<span style={{ fontWeight: 500, color: '#6c757d' }}>Password</span>}
                  style={{ marginBottom: '16px' }}
                >
                  <Input.Password
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter your password"
                    size="large"
                  />
                </Form.Item>

                <Button
                  type="primary"
                  block
                  size="large"
                  loading={signingIn}
                  onClick={() => { signIn(); setSigningIn(true) }}
                  icon={!signingIn && <BiLogIn />}
                  style={{ marginTop: '24px', marginBottom: '16px' }}
                  className='rounded-0'
                >
                  {signingIn ? 'Logging in...' : 'LOGIN'}
                </Button>

                <Button
                  type="link"
                  block
                  onClick={() => { setShowTokenForm(true); setShowLoginForm(false); setShowResetForm(false) }}
                  style={{ padding: 0 }}
                >
                  Forgot password?
                </Button>
              </Form>
            ) : showTokenForm ? (
              <Form layout="vertical" id="reset-form">
                <p style={{ textAlign: 'left', marginBottom: '20px' }}>
                  Enter your email address to reset your password
                </p>

                <Form.Item
                  label={<span style={{ fontWeight: 500, color: '#6c757d' }}>Email address</span>}
                  style={{ marginBottom: '16px' }}
                >
                  <Input
                    type="email"
                    value={email}
                    onChange={(e) => setUsername(e.target.value)}
                    placeholder="Enter your email"
                    size="large"
                  />
                </Form.Item>

                <Button
                  type="primary"
                  block
                  size="large"
                  loading={requestingToken}
                  onClick={() => { requestResetToken(); setRequestingToken(true) }}
                  icon={!requestingToken && <BiLogIn />}
                  style={{ marginTop: '24px', marginBottom: '16px' }}
                  className='rounded-0'
                >
                  {requestingToken ? 'Sending token...' : 'SEND PASSWORD TOKEN'}
                </Button>

                <Button
                  type="link"
                  block
                  onClick={() => { setShowLoginForm(true); setShowTokenForm(false); setShowResetForm(false) }}
                  style={{ padding: 0 }}
                >
                  Go back to login
                </Button>
              </Form>
            ) : showResetForm ? (
              <Form layout="vertical" id="reset-form">
                <p style={{ textAlign: 'left', marginBottom: '20px' }}>Set a new password</p>

                <Form.Item
                  label={<span style={{ fontWeight: 500, color: '#6c757d' }}>Email</span>}
                  style={{ marginBottom: '16px' }}
                >
                  <Input
                    type="email"
                    value={email}
                    readOnly
                    size="large"
                    disabled
                  />
                </Form.Item>

                <Form.Item
                  label={<span style={{ fontWeight: 500, color: '#6c757d' }}>Enter the OTP</span>}
                  style={{ marginBottom: '16px' }}
                >
                  <Input
                    type="text"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    placeholder="Enter OTP"
                    size="large"
                  />
                </Form.Item>

                <Form.Item
                  label={<span style={{ fontWeight: 500, color: '#6c757d' }}>New password</span>}
                  style={{ marginBottom: '16px' }}
                >
                  <Input.Password
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    placeholder="Enter new password"
                    size="large"
                  />
                </Form.Item>

                <Form.Item
                  label={<span style={{ fontWeight: 500, color: '#6c757d' }}>Re-type new password</span>}
                  style={{ marginBottom: '16px' }}
                >
                  <Input.Password
                    value={newPasswordConfirm}
                    onChange={(e) => setNewPasswordConfirm(e.target.value)}
                    placeholder="Confirm new password"
                    size="large"
                  />
                </Form.Item>

                <Button
                  type="primary"
                  block
                  size="large"
                  loading={resetingPassword}
                  onClick={() => { resetPassword(); setResetingPassword(true) }}
                  icon={!resetingPassword && <BiLogIn />}
                  style={{ marginTop: '24px', marginBottom: '16px' }}
                  className='rounded-0'
                >
                  {resetingPassword ? 'Resetting password...' : 'RESET PASSWORD'}
                </Button>

                <Button
                  type="link"
                  block
                  onClick={() => { setShowLoginForm(true); setShowTokenForm(false); setShowResetForm(false) }}
                  style={{ padding: 0 }}
                >
                  Go back to login
                </Button>
              </Form>
            ) : null}
          </Card>
        ) : (
          <div style={{ textAlign: 'center' }}>
            <Spin size="large" />
            <p style={{ color: '#0240c4', marginTop: '20px', fontWeight: 'bold', textTransform: 'uppercase' }}>
              Wait as we set you up...
            </p>
          </div>
        )}
      </div>
    </div>
  )
}

export default LoginPage
